export enum LocaleLanguage {
    EN_US = 'en_US',
    SV_SE = 'sv_SE',
    NO_NO = 'no_NO',
    DA_DK = 'da_DK',
    FI_FI = 'fi_FI',
    DEBUG = 'debug',
}

export enum LocaleDateFormat {
    ISO = 'ISO',
    CENTRAL_EUROPE = 'CENTRAL_EUROPE',
    WESTERN_EUROPE = 'WESTERN_EUROPE',
    US = 'US',
}

export enum LocaleNumberFormat {
    ENGLISH = 'ENGLISH',
    EUROPEAN = 'EUROPEAN',
    ISO = 'ISO',
    SWISS = 'SWISS',
    INDIAN = 'INDIAN',
}

export type LocaleFormat = {
    language: LocaleLanguage;
    date: LocaleDateFormat;
    number: LocaleNumberFormat;
};

export const DEFAULT_LOCALE_FORMAT: LocaleFormat = {
    language: LocaleLanguage.EN_US,
    date: LocaleDateFormat.ISO,
    number: LocaleNumberFormat.ISO,
};
